export const changeToTitleCase = (words) =>
    words ? words
        .split(' ')
        .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1).toLowerCase())
        .join(' ') : words;

export const getConversationMessageCount = (conversation) =>
    conversation?.messageCount ?? conversation?.conversationVersion ?? 1;

export const formatInAppMessageHtml = (message) =>
    String(message || '').replace(/{{break}}/g, '<br />');

const normalizeMessageBody = (value) => String(value || '').trim();

export const isDuplicateInThread = ({ draft, threadMessages, lastMessage, conversationVersion } = {}) => {
    if (conversationVersion !== 3) {
        return false;
    }

    const normalizedDraft = normalizeMessageBody(draft);
    if (!normalizedDraft) {
        return false;
    }

    const candidates = [
        ...(Array.isArray(threadMessages) ? threadMessages : []),
        ...(lastMessage ? [lastMessage] : []),
    ];

    return candidates.some((item) => normalizeMessageBody(item?.message) === normalizedDraft);
};
